import React from 'react';
import SubHeader from '../../layout/components/SubHeader';
import PasswordUpdateComponent from './PasswordUpdateComponent';
import './PasswordUpdate.css';

function PasswordUpdate() {
    return (
        <div className="ecx-page password-update-page ecx-page--full-width">
            <SubHeader
                title="Password Settings"
                description="Update your login password and keep your account secure"
                icon="bi-shield-lock"
                containerClass="w-100 px-4"
            />

            <div className="ecx-page-body">
                <PasswordUpdateComponent />
            </div>
        </div>
    );
}

export default PasswordUpdate;
